require('./src/index.css');
require('@uifabric/icons').initializeIcons();
